export default function nl2br(string) {
  return string.replace(/\n/g, "<br />")
}
